import * as React from 'react';
import styled from 'styled-components';
const Outer = styled.div `
  padding: 40px 30px;
`;
export const NodeInnerDefault = ({ node }) => {
    return (React.createElement(Outer, null,
        React.createElement("div", null,
            "Type: ",
            node.type)));
};
